export default "__VITE_ASSET__cede807f__"